import { S3 } from 'aws-sdk';
import { AuthService, ObjectServerConfiguration } from '../auth/auth.service';
import { X } from '@angular/cdk/keycodes';

var AWS = require('aws-sdk');

export function getAWS(config: ObjectServerConfiguration) {
    var region = config.region;
    var spacesEndpoint = new AWS.Endpoint(region + config.awsEndpoint);
    var bucketName = config.bucketName;

    return new AWS.S3({
        endpoint: spacesEndpoint,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey
    });
}


export async function UploadImage(DocumentName: string, image: any, config: ObjectServerConfiguration, folderPath: String) {
    var s3 = getAWS(config);
    const photoKey = config.albumPhotosKey + config.folderParth + folderPath + "/" + DocumentName;
    var params = {
        ACL: 'public-read',
        Bucket: config.bucketName,
        Key: photoKey,
        Body: image
    };

    return await s3.putObject(params).promise()
        .then((res: objectresponse) => {
            res.status = true;
            res.filepath = photoKey;
            return res;
        })
        .catch((err: any) => {
            err.status = false;
            err.error = err;
            return err;
        });

}
export async function ImageDelete(imageName: any, config: ObjectServerConfiguration) {
    var s3 = getAWS(config);
    const photoKey = imageName.replace(config.downloadPath + config.albumPhotosKey, '');
    var params = {
        Bucket: config.bucketName,
        Key: photoKey
    };
    return await s3.deleteObject(params).promise()
        .then((data) => {
            console.log('sucessfully deleted ' + imageName, data)
            return true
        })
        .catch((err) => console.log('err: ', err));
}

export class objectresponse {
    status: boolean;
    filepath: string;
    error: string;
}


